import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Thin wrapper so call sites read `cn(...)` consistently across the app.
 *
 * Uses tailwind-merge on top of clsx so that later, more specific classes
 * (e.g. a caller-supplied `className` or `panelClassName` override) reliably
 * win over a component's own base classes for the same CSS property -
 * regardless of the order Tailwind happens to emit the underlying utility
 * rules in the generated stylesheet. Without this, two same-specificity
 * utilities like `bg-white` and `bg-brand-900` are resolved by *stylesheet*
 * order, not by the order they appear in the `class` attribute, which is
 * what previously made the mobile nav drawer render with a white panel
 * despite passing `panelClassName="bg-brand-900"`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
